import React from 'react';

type Props = {
    item: any;
    /** table: default dark text; modal: light text on dark background */
    variant?: 'table' | 'modal';
};

const FILLED_SLOT_STATUSES = new Set(['assigned', 'started', 'completed']);

/**
 * Lists every photographer on `service_slots` when present; otherwise legacy
 * `photographer_assigned.photographer_details.name`.
 *
 * Only slots that are actually filled (assigned/started/completed + userId)
 * count — open/notified slots may retain a stale `name` after photographer cancel
 * and must not appear under "Assigned To".
 */
const AssignedPhotographersDisplay = ({ item, variant = 'table' }: Props) => {
    const assignedSlots = (item?.service_slots || []).filter((s: any) => {
        const uid = s?.photographer_assigned?.userId;
        if (uid == null || uid === '') return false;
        return FILLED_SLOT_STATUSES.has(String(s?.status || '').toLowerCase());
    });
    if (assignedSlots.length === 0) {
        const legacyUid = item?.photographer_assigned?.userId;
        const legacyAccepted = item?.photographer_assigned?.isOrderAccepted === true;
        const legacy =
            legacyUid && legacyAccepted
                ? item?.photographer_assigned?.photographer_details?.name
                : null;
        return <>{legacy || '-'}</>;
    }

    return (
        <ul
            style={{
                margin: 0,
                paddingLeft: '1.05rem',
                maxWidth: variant === 'table' ? 280 : '100%',
                listStyleType: 'disc',
            }}
        >
            {assignedSlots.map((s: any, i: number) => {
                // Client-reported: only show the OTP up until the order actually
                // starts (correct OTP entered by the photographer) — once that
                // happens, status moves past 'assigned' and the OTP is no longer
                // shown at all, regardless of its own expiry time.
                const otpCode = s?.status === 'assigned' ? s?.start_otp?.code : null;
                return (
                    <li
                        key={`${s.service_type}-${s.slot_index ?? 0}-${i}`}
                        style={{ marginBottom: variant === 'table' ? 6 : 10, color: variant === 'modal' ? '#fff' : undefined }}
                    >
                        <span style={{ fontWeight: 600 }}>{s.photographer_assigned?.name || '—'}</span>
                        {otpCode ? (
                            <div style={{ fontSize: 12, marginTop: 2, opacity: 0.85 }}>
                                OTP: <span style={{ fontWeight: 700, letterSpacing: 0.5 }}>{otpCode}</span>
                            </div>
                        ) : null}
                    </li>
                );
            })}
        </ul>
    );
};

export default AssignedPhotographersDisplay;
